import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Container } from "@mui/system";
import { Typography, Grid, Box } from "@mui/material";

//Hooks
import { useDocument } from "../hooks/useDocument";

const Delivery = React.forwardRef((props, ref) => {
  const { id } = useParams();
  const { document } = useDocument("Delivery");
  const { document: data } = useDocument("sign");

  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [rep, setRep] = useState("");
  const [number, setNumber] = useState("");
  const [sign, setSign] = useState("");
  const [position, setPosition] = useState("");
  const [signature, setSignature] = useState("");
  const [items, setItems] = useState([
    {
      description: "",
      quantity: "",
      part: "",
    },
  ]);

  useEffect(() => {
    const detail = async () => {
      try {
        const docSnap = await document(id);
        const docSnap1 = await data("Signature");
        // console.log(docSnap.data())
        setSignature(docSnap1.data().file);
        setName(docSnap.data().name);
        setItems(docSnap.data().items);
        setDate(docSnap.data().date);
        setOrderNo(docSnap.data().orderNo);
        setRep(docSnap.data().rep);
        setNumber(docSnap.data().number);
        setSign(docSnap.data().sign);
        setPosition(docSnap.data().position);
      } catch (error) {
        console.log(error);
      }
    };
    if ((id !== undefined || id !== "") && id !== ":id") {
      detail();
    }

    // eslint-disable-next-line
  }, [id]);

  function addLeadingZeroes(word) {
    if (isNaN(word)) {
      return "Invalid input";
    }

    const wordStr = word.toString();

    if (wordStr.length === 1) {
      return "000" + wordStr;
    }
    if (wordStr.length === 2) {
      return "00" + wordStr;
    }

    if (wordStr.length === 3) {
      return "0" + wordStr;
    }

    if (wordStr.length === 4) {
      return wordStr;
    }
    return word;
  }

  return (
    <div ref={ref}>
      <Container maxWidth="xl" sx={{ backgroundColor: "white" }}>
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={3}>
            <img src="/logo1.png" alt="logo" />
          </Grid>
          <Grid item xs={8} sx={{ textAlign: "center" }}>
            <Typography variant="h4">AKOLISA CRANE LIMITED</Typography>
            <Typography variant="body1" sx={{ fontSize: "13px" }}>
              <b>ENGINEERING, SERVICES & CERTIFICATION OF LIFTING EQUIPMENT</b>
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "12px" }}>
              <b>HEAD OFFICE:</b> No. 49 Okwuro water-front off standard rd,
              Elelenwo. PHC
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "12px" }}>
              <b>EMAIL: </b> contact@akolisacranes.com <b>WEBSITE:</b>{" "}
              www.akolisacranes.com
            </Typography>
            <Typography variant="body2" sx={{ fontSize: "12px" }}>
              <b>TEL NO: 084-757807, 084-777926 Mobile No: 08064347013</b>
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            marginY: 4,
          }}
        >
          <Box
            sx={{
              background: "gray",
              color: "#fff",
              fontWeight: "bold",
              padding: 2,
              borderRadius: 2,
              marginX: 20,
            }}
          >
            <Typography variant="h2">Delivery Note</Typography>
          </Box>
          <Box
            sx={{
              padding: 2,
              borderRadius: 2,
              fontWeight: "bold",
              alignItems: "right",
            }}
          >
            <Typography variant="h3">{addLeadingZeroes(number)}</Typography>
          </Box>
        </Grid>
        <Grid
          copntainer
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginX: 4,
          }}
        >
          <Grid item xs={12} md={4} marginY={4}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Typography variant="body1">
                <b>To:</b>
              </Typography>
              <Typography variant="body1">{name}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} spacing={4}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Typography variant="body1">
                <b>Date:</b>
              </Typography>
              <Typography variant="body1">{date}</Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Typography variant="body1">
                <b>Order No:</b>
              </Typography>
              <Typography variant="body1">{orderNo}</Typography>
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}
            >
              <Typography variant="body1">
                <b>Rep:</b>
              </Typography>
              <Typography variant="body1">{rep}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid sx={{ border: "1px solid" }}>
          <Grid
            container
            sx={{ backgroundColor: "gray", color: "#fff", fontWeight: "bold" }}
          >
            <Grid item xs={1} sx={{ border: "1px solid", pt: 2 }}>
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                <b>S/N</b>
              </Typography>
            </Grid>
            <Grid item xs={6} sx={{ border: "1px solid", pt: 2 }}>
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                <b>Job / Part Description</b>
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ border: "1px solid", pt: 2 }}>
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                <b>QTY</b>
              </Typography>
            </Grid>

            <Grid item xs={3} sx={{ border: "1px solid", pt: 2 }}>
              <Typography variant="body1" sx={{ textAlign: "center" }}>
                <b>Part No</b>
              </Typography>
            </Grid>
          </Grid>
          {items.map((desc, i) => {
            return (
              <Grid container key={i}>
                <Grid item xs={1} sx={{ border: "1px solid" }}>
                  <Typography variant="body1" sx={{ textAlign: "center" }}>
                    {i + 1}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ border: "1px solid" }}>
                  <Typography variant="body1" sx={{ pl: 2 }}>
                    {desc.description}
                  </Typography>
                </Grid>
                <Grid item xs={2} sx={{ border: "1px solid" }}>
                  <Typography variant="body1" sx={{ textAlign: "center" }}>
                    {desc.quantity}
                  </Typography>
                </Grid>
                <Grid item xs={3} sx={{ border: "1px solid" }}>
                  <Typography variant="body1" sx={{ textAlign: "center" }}>
                    {desc.part}
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        <Grid
          container
          sx={{
            mt: 8,
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={5} sx={{ textAlign: "center" }}>
            <Typography>{sign}</Typography>
            <Typography variant="body2">{position}</Typography>
          </Grid>
          <Grid
            item
            xs={5}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={signature} alt="signature" style={{ width: "120px" }} />
            <Typography>{date}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            mt: 5,
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={5} sx={{ textAlign: "center" }}>
            <p>__________________________________________</p>
            <Typography>For Customer</Typography>
          </Grid>
          <Grid item xs={5} sx={{ textAlign: "center" }}>
            <p>_____________________________</p>
            <Typography>Sign/Date</Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
});

export default Delivery;
